<!-- 重複して発券した場合 -->
<template>
  <ItemDialog ref="dialogRef" image-type="alert">
    <template #content-area>
      <h2>同じ列車の特急券を既に購入されています</h2>
      <p class="text-center">
        購入済み特急券一覧をご確認ください。<br />
        ご確認の上、さらに追加で購入される場合には、1分以上経過後に再度お試しください。
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogTemporaryBlocked",
  setup() {
    const dialogRef = ref(null);

    const openDialog = () => {
      dialogRef.value.open();
    };

    const closeDialog = () => {
      dialogRef.value.close();
    };

    return {
      dialogRef,
      openDialog,
      closeDialog,
    };
  },
};
</script>
